import styled, { css } from 'styled-components';
import { Label } from './Label.styled';

export const Checkbox = styled.div<{ disabled?: boolean }>`
    display: flex;
    justify-items: center;
    gap: 8px;

    > ${Label} {
        cursor: ${(props) => (props.disabled ? css`default` : css`pointer`)};
    }
`;
